<script setup>
import { computed } from 'vue';
import AiSuggestionList from '@/components/result/ai-literacy-2026/AiSuggestionList.vue';
import { areaName, improvementsFromStudent, materialQrUrl } from '@/components/result/ai-literacy-2026/data/reportLogic';
import { AREA_CODES } from '@/components/result/ai-literacy-2026/data/reportData';

const props = defineProps({
    studentData: Object
});

const userRole = 'student';

// 맞춤 학습 제안 (엑셀 '향상자료' 시트)
//  - DB의 improvement1~4_type/materials(영역코드/문항번호)가 있으면 그 순서대로 표시
//  - 없으면 wrong_questions(틀린 문항번호 배열)로 "쉬운 문항 순 · 영역 미중복" 규칙 적용 (reportLogic.pickImprovements)
const aiSuggestionData = computed(() => {
    const materials = improvementsFromStudent(props.studentData);
    return {
        student: materials.map(m => ({
            // 슬롯(improvement1~4)이 자료 order 순서로 채워져 행 순서가 영역 순서(a~d)와 다를 수 있으므로
            // 왼쪽 영역 아이콘은 행 번호가 아니라 자료의 영역 코드로 고른다.
            ...(AREA_CODES.indexOf(m.code) >= 0 ? { iconIndex: AREA_CODES.indexOf(m.code) } : {}),
            category: `${areaName(m.code)}`,
            desc: m.feedback,
            resource: {
                text: m.study,
                url: m.url,
                qr: materialQrUrl(m)
            }
        }))
    };
});
</script>

<template>
  <div class="report-inner">   
    <div class="card-wrap">
      <AiSuggestionList :userRole="userRole" :data="aiSuggestionData" />       
    </div>        
  </div>
</template>
